import { useProductPageStore } from '@hooks/states/useProductPageStore';
import { findInternationalProductSku } from '@libs/product.helper';
import { useEffect } from 'react';

export const useHasArtnrParam = () => {
  const allProducts = useProductPageStore(state => state.allProducts);
  const setSelectedVariantSku = useProductPageStore(state => state.setSelectedVariantSku);

  useEffect(() => {
    if (window?.location?.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const internationalProductId = findInternationalProductSku(
        allProducts,
        urlParams.get('artnr') || urlParams.get('artNr')
      );
      setSelectedVariantSku(internationalProductId);
    }
  }, []);
};
